export const catalogConfigs = {
  title: {
    default: "HANBIT MD",
    ko: "HANBIT MD",
  },
  langSet: ["en"],
  pageMap: [
    { name: "cover" },
    { name: "intro", outlets: ["1", "2", "3"] },
    { name: "catalog-index" },
    {
      name: "company",
      outlets: ["overview", "history"],
    },
    {
      name: "research",
      outlets: [
        "patents",
        {
          name: "papers",
          outlets: ["2023", "2025"],
        },
      ],
    },
    {
      name: "product",
      outlets: [
        { name: "precision", outlets: ["1", "2", "3"] },
        {
          name: "automatic",
          outlets: [
            { name: "accu-drip", outlets: ["1", "2", "3"] },
            { name: "smart-drip", outlets: ["1", "2"] },
          ],
        },
      ],
    },

    {
      name: "contact",
      outlets: ["info"],
    },
    { name: "last" },
  ],
  autoplay: {
    delay: 4000,
    loop: true,
  },
  width: 1920,
  height: 1080,
  breakpoint: 768,
};

const ENV = process.env;
export const IS_DEV = ENV.REACT_APP_IS_DEV;
export const ROUTER_TYPE = ENV.REACT_APP_ROUTER_TYPE;
export const BASE_NAME = ENV.REACT_APP_BASE_NAME;
export const PUBLIC_URL = ENV.PUBLIC_URL;
export const IMG_URL = `${PUBLIC_URL}/images`;
